import React from "react";

const About = () => {
	return (
		<div>
			<h1>About</h1>
			this contains things like what i like, where i have learnt and my
			history and stuff. like the whole resume thing. So you can include
			your plus points and your interests hobbies and stuff. languages and
			things you are good at. schools you've been to, places you studied.
		</div>
	);
};

export default About;
